import { Icon } from '@chakra-ui/react';

export const Details2 = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M9.05263 8.8C9.05263 9.24183 8.67561 9.6 8.21053 9.6C7.74544 9.6 7.36842 9.24183 7.36842 8.8C7.36842 8.35817 7.74544 8 8.21053 8C8.67561 8 9.05263 8.35817 9.05263 8.8Z"
      fill="currentColor"
    />
    <path
      d="M11.5789 8.8C11.5789 8.35817 11.956 8 12.4211 8H15.7895C16.2546 8 16.6316 8.35817 16.6316 8.8C16.6316 9.24183 16.2546 9.6 15.7895 9.6H12.4211C11.956 9.6 11.5789 9.24183 11.5789 8.8Z"
      fill="currentColor"
    />
    <path
      d="M9.05263 12C9.05263 12.4418 8.67561 12.8 8.21053 12.8C7.74544 12.8 7.36842 12.4418 7.36842 12C7.36842 11.5582 7.74544 11.2 8.21053 11.2C8.67561 11.2 9.05263 11.5582 9.05263 12Z"
      fill="currentColor"
    />
    <path
      d="M11.5789 12C11.5789 11.5582 11.956 11.2 12.4211 11.2H15.7895C16.2546 11.2 16.6316 11.5582 16.6316 12C16.6316 12.4418 16.2546 12.8 15.7895 12.8H12.4211C11.956 12.8 11.5789 12.4418 11.5789 12Z"
      fill="currentColor"
    />
    <path
      d="M9.05263 15.2C9.05263 15.6418 8.67561 16 8.21053 16C7.74544 16 7.36842 15.6418 7.36842 15.2C7.36842 14.7582 7.74544 14.4 8.21053 14.4C8.67561 14.4 9.05263 14.7582 9.05263 15.2Z"
      fill="currentColor"
    />
    <path
      d="M11.5789 15.2C11.5789 14.7582 11.956 14.4 12.4211 14.4H15.7895C16.2546 14.4 16.6316 14.7582 16.6316 15.2C16.6316 15.6418 16.2546 16 15.7895 16H12.4211C11.956 16 11.5789 15.6418 11.5789 15.2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.4C4 5.07452 5.13107 4 6.52632 4H17.4737C18.8689 4 20 5.07452 20 6.4V17.6C20 18.9255 18.8689 20 17.4737 20H6.52632C5.13107 20 4 18.9255 4 17.6V6.4ZM6.52632 5.6C6.06123 5.6 5.68421 5.95817 5.68421 6.4V17.6C5.68421 18.0418 6.06123 18.4 6.52632 18.4H17.4737C17.9388 18.4 18.3158 18.0418 18.3158 17.6V6.4C18.3158 5.95817 17.9388 5.6 17.4737 5.6H6.52632Z"
      fill="currentColor"
    />
  </Icon>
);
